export default __webpack_public_path__ + "static/media/tik-tok.a8f57c9b.svg";